import Controller, { OnAfterFetch, OnChange, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { Endpoint } from '../../../constants/endpoints';
import { AuthenticationService, HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ApplicationRoute } from '../../../constants/routes';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ButtonAPI, CheckboxAPI } from '@philips-internal/oswald-ui-components';
import { FragmentNames, TermsOfUseAliases } from '../../../codegen';

interface TermsOfUseData {
  dsTermo: string;
  nrSequencia: number;
}

@Controller({ component: TermsOfUseAliases.LAYOUT_GENERAL, fragment: FragmentNames.TERMS_OF_USE })
class TermsOfUseController extends BaseController {

  @Inject(TermsOfUseAliases.CHECKBOX_AGREE)
  private checkBoxAgree!: CheckboxAPI;

  @Inject(TermsOfUseAliases.BUTTON_CONFIRM)
  private buttonConfirm!: ButtonAPI;

  termsOfUseResponse!: TermsOfUseData;

  @OnMount(TermsOfUseAliases.CHECKBOX_AGREE)
  handleMountCheckboxAgree(): void {
    const expressionAgreeWithThe = MessageService.translate('terms-of-use.agree-with-the');
    const expressionTermsUse = MessageService.translate('text.terms-use-and-responsibility');
    const label = `${expressionAgreeWithThe} ${expressionTermsUse?.toLowerCase()}`
    this.checkBoxAgree.setLabel(label);
  }

  @OnChange(TermsOfUseAliases.CHECKBOX_AGREE)
  onChangeCheckBox(): void {
    this.checkBoxAgree.setValue(!this.checkBoxAgree.getValue());
    this.buttonConfirm.setEnabled(this.checkBoxAgree.getValue());
  }

  @OnAfterFetch(TermsOfUseAliases.FETCH_TERMS_OF_USE)
  onAfterFetchTerms(e: FetchEvent): void {
    this.termsOfUseResponse = e.data as TermsOfUseData;
  }

  @OnClose(TermsOfUseAliases.MODAL_CONTENT)
  onClose(): void {
    AuthenticationService.logout().then(() => {
      AuthenticationService.redirectToLogin();
    });
  }

  @OnClick(TermsOfUseAliases.BUTTON_CONFIRM)
  onClickConfirm(): void {
    const nrSequencia = this.termsOfUseResponse.nrSequencia;
    HttpService.post(Endpoint.TERMS_OF_USE_ACCEPTED, { nrSequencia: nrSequencia })
      .then(() => {
        this.historyService.push(ApplicationRoute.SPOTLIGHT);
      });
  }
}

export default TermsOfUseController;